import React from 'react';
import { useTranslation } from 'react-i18next';
import PeopleIcon from 'assets/icon-user';
import { getShortDescription } from 'utils';
import { HostedBy, HostMediaImageResolutions } from 'types/listingV3';
import {
  Footer,
  HostedBy as HostedByComponent,
  Title4,
  DefaultUserAvatar,
  HostedByImageWrap,
  HostedByContent,
} from './styles';
import { ProfilePicture } from '../../atoms/ProfilePicture';

interface HostedContainerProps {
  hostedBy?: HostedBy;
}

const HostedContainer = ({ hostedBy }: HostedContainerProps) => {
  const { t } = useTranslation();

  const { firstName, lastName, profilePicture, description } = hostedBy ?? {};

  if (firstName === 'No Host' || !firstName) return null;

  return (
    <Footer className="featured-experience__item-footer">
      <Title4 className="featured-experience__item-hosted-by-label host">
        {t('hostedBy')} {`${firstName} ${lastName}`}
      </Title4>
      <HostedByComponent className="featured-experience__item-hosted-by-wrapper">
        {profilePicture ? (
          <HostedByImageWrap>
            <ProfilePicture
              className="featured-experience__item-hosted-by-image"
              src={profilePicture.uri[HostMediaImageResolutions['360w']]}
              alt={t('profileImageOfHost', { hostName: firstName })}
            />
          </HostedByImageWrap>
        ) : (
          <DefaultUserAvatar>
            <PeopleIcon aria-label={t('hostUserIcon')} />
          </DefaultUserAvatar>
        )}
        <HostedByContent className="featured-experience__item-hosted-by-content">
          {getShortDescription(description, 150)}
        </HostedByContent>
      </HostedByComponent>
    </Footer>
  );
};

export default HostedContainer;
